/**
 * Questo file contiene il tipo 'formStep'
 * riporta l'enim dei vari step del forum per renderlo piu leggibile
 */

export enum PaymentMode {
	SaltaPagamento = 0,
	Bonifico = 1,
	PayPal = 2,
	CartaDiCredito = 3,
}
